import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-restore-crawling-web-form',
  templateUrl: './restore-crawling-web-form.component.html',
  styleUrls: ['./restore-crawling-web-form.component.scss']
})
export class RestoreCrawlingWebFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
